import { initializeWootricScript } from './wootric';

/*
 *  This is where we export the starting point scripts for Wootric
 */

export { initializeWootricScript };
